import {Injectable} from '@angular/core';
import {EventResponse} from "../../shared/model/response/event/event-response.model";
import {ConstantsEnum} from "../../shared/enums/constants-enum";
import {EventStatus} from "../../shared/enums/status.enum";

@Injectable({providedIn: 'root'})
export class EventUtilService {

  constructor() {
  }

  displayEventImage(event: EventResponse): string {

    const isPending = event?.status?.code == EventStatus.PENDING

    const visibleImage = event?.blurredImagePath || event?.originalImagePath

    if (!visibleImage) return isPending ? ConstantsEnum.IMAGE_EVENT_PENDING : ConstantsEnum.IMAGE_EVENT_EMPTY

    if (event.explicitImage) return ConstantsEnum.IMAGE_EVENT_EXPLICIT

    return visibleImage
  }

}
